import React, { useContext } from 'react';
import { tokens } from '@theme/tokens';
import type { BaseTheme } from './makeBaseTheme';
import { makeBaseTheme } from './makeBaseTheme';

export const ThemeContext = React.createContext<BaseTheme>(
  makeBaseTheme(tokens)
);
export const useTheme = () => useContext(ThemeContext);
